/* HotDawgs — Find Your Size quiz
   4 steps: breed, gender, name, weight (skippable) → bed size recommendation */

const HD_BREEDS = [
  ['Chihuahua', 'Small'], ['Pomeranian', 'Small'], ['Yorkshire Terrier', 'Small'],
  ['Maltese', 'Small'], ['Shih Tzu', 'Small'], ['Dachshund', 'Small'],
  ['Pug', 'Small'], ['French Bulldog', 'Small'], ['Boston Terrier', 'Small'],
  ['Cavalier King Charles Spaniel', 'Small'], ['Miniature Pinscher', 'Small'],
  ['Papillon', 'Small'], ['Havanese', 'Small'], ['Jack Russell Terrier', 'Small'],
  ['West Highland White Terrier', 'Small'], ['Cairn Terrier', 'Small'],
  ['Toy Poodle', 'Small'], ['Miniature Poodle', 'Small'], ['Pekingese', 'Small'],
  ['Bichon Frise', 'Small'], ['Corgi (Pembroke Welsh)', 'Small'],
  ['Corgi (Cardigan Welsh)', 'Small'], ['Miniature Schnauzer', 'Small'],
  ['Italian Greyhound', 'Small'], ['Rat Terrier', 'Small'],

  ['Beagle', 'Medium'], ['Cocker Spaniel', 'Medium'], ['Border Collie', 'Medium'],
  ['Australian Cattle Dog', 'Medium'], ['English Bulldog', 'Medium'],
  ['Basset Hound', 'Medium'], ['Whippet', 'Medium'], ['Brittany', 'Medium'],
  ['English Springer Spaniel', 'Medium'], ['Standard Poodle', 'Medium'],
  ['Australian Shepherd', 'Medium'], ['Staffordshire Bull Terrier', 'Medium'],
  ['American Staffordshire Terrier', 'Medium'], ['Shiba Inu', 'Medium'],
  ['Basenji', 'Medium'], ['Shetland Sheepdog', 'Medium'], ['Chow Chow', 'Medium'],
  ['Keeshond', 'Medium'], ['Portuguese Water Dog', 'Medium'],

  ['Labrador Retriever', 'Large'], ['Golden Retriever', 'Large'],
  ['German Shepherd', 'Large'], ['Boxer', 'Large'], ['Doberman Pinscher', 'Large'],
  ['Rottweiler', 'Large'], ['Siberian Husky', 'Large'], ['Weimaraner', 'Large'],
  ['Vizsla', 'Large'], ['Dalmatian', 'Large'], ['Bloodhound', 'Large'],
  ['Collie', 'Large'], ['Belgian Malinois', 'Large'], ['Alaskan Malamute', 'Large'],
  ['Rhodesian Ridgeback', 'Large'], ['Pointer', 'Large'], ['Akita', 'Large'],

  ['Great Dane', 'Extra Large'], ['Mastiff', 'Extra Large'],
  ['Saint Bernard', 'Extra Large'], ['Newfoundland', 'Extra Large'],
  ['Bernese Mountain Dog', 'Extra Large'], ['Irish Wolfhound', 'Extra Large'],
  ['Leonberger', 'Extra Large'], ['Great Pyrenees', 'Extra Large'],
  ['Anatolian Shepherd', 'Extra Large'], ['Cane Corso', 'Extra Large'],
  ['Tibetan Mastiff', 'Extra Large'], ['Neapolitan Mastiff', 'Extra Large'],

  ['Mixed breed / not sure', 'Medium'],
];

function hdQuizAssetUrl(name) {
  return (window.HD && window.HD.settings && window.HD.settings.quizImages && window.HD.settings.quizImages[name]) || '';
}

const HD_SIZE_COPY = {
  get Small() { return { label: 'Small', range: 'up to 20 lb', img: hdQuizAssetUrl('hero-golden') }; },
  get Medium() { return { label: 'Medium', range: '21–45 lb', img: hdQuizAssetUrl('lifestyle-family') }; },
  get Large() { return { label: 'Large', range: '46–80 lb', img: hdQuizAssetUrl('compare-cold-warm') }; },
  get 'Extra Large'() { return { label: 'Extra Large', range: '81 lb+', img: hdQuizAssetUrl('hero-golden') }; },
};

function hdSizeFromWeight(lb) {
  if (lb <= 20) return 'Small';
  if (lb <= 45) return 'Medium';
  if (lb <= 80) return 'Large';
  return 'Extra Large';
}

(function () {
  const state = { breed: null, size: null, gender: null, name: '', weight: '' };
  let step = 1;
  const totalSteps = 4;

  const overlay = document.getElementById('quiz-overlay');
  if (!overlay) return;

  const openBtns = document.querySelectorAll('[data-open-quiz]');
  const closeBtn = document.getElementById('quiz-close');
  const progressBars = overlay.querySelectorAll('.quiz-progress span i');
  const steps = overlay.querySelectorAll('.quiz-step');

  function showStep(n) {
    steps.forEach((s) => s.classList.toggle('active', Number(s.dataset.step) === n));
    progressBars.forEach((bar, i) => { bar.style.width = i < n ? '100%' : '0%'; });
  }

  function openQuiz() {
    overlay.classList.add('active');
    step = 1;
    showStep(1);
    document.body.style.overflow = 'hidden';
  }
  function closeQuiz() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  openBtns.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openQuiz(); }));
  closeBtn?.addEventListener('click', closeQuiz);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) closeQuiz(); });

  // Arriving from another page via "Find Your Size" — index.html?quiz=1
  if (new URLSearchParams(window.location.search).get('quiz') === '1') {
    openQuiz();
  }

  // Step 1: breed --------------------------------------------------------
  const breedSearch = document.getElementById('breed-search');
  const breedList = document.getElementById('breed-list');

  function renderBreedList(filter = '') {
    const f = filter.trim().toLowerCase();
    const matches = HD_BREEDS.filter(([name]) => name.toLowerCase().includes(f)).slice(0, 8);
    breedList.innerHTML = matches
      .map(([name, size]) => `<button type="button" data-breed="${name}" data-size="${size}">${name}</button>`)
      .join('') || '<button type="button" disabled>No matches — try "mixed"</button>';
  }
  renderBreedList();
  breedSearch?.addEventListener('input', (e) => renderBreedList(e.target.value));
  breedList?.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-breed]');
    if (!btn) return;
    state.breed = btn.dataset.breed;
    state.size = btn.dataset.size;
    breedSearch.value = state.breed;
    [...breedList.children].forEach((c) => c.classList.remove('selected'));
    btn.classList.add('selected');
    document.getElementById('step1-next').disabled = false;
  });

  // Step 2: gender ---------------------------------------------------------
  overlay.querySelectorAll('[data-gender]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.gender = btn.dataset.gender;
      overlay.querySelectorAll('[data-gender]').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      document.getElementById('step2-next').disabled = false;
    });
  });

  // Step 3: name -------------------------------------------------------------
  const nameInput = document.getElementById('dog-name');
  nameInput?.addEventListener('input', () => {
    state.name = nameInput.value.trim();
    document.getElementById('step3-next').disabled = state.name.length === 0;
  });

  // Step 4: weight (skippable) -----------------------------------------------
  const weightInput = document.getElementById('dog-weight');

  function finishQuiz() {
    if (weightInput && weightInput.value) {
      state.weight = weightInput.value;
      state.size = hdSizeFromWeight(parseFloat(weightInput.value));
    }
    renderResult();
    step = 5;
    steps.forEach((s) => s.classList.toggle('active', s.dataset.step === 'result'));
    progressBars.forEach((bar) => { bar.style.width = '100%'; });
  }
  document.getElementById('step4-finish')?.addEventListener('click', finishQuiz);
  document.getElementById('step4-skip')?.addEventListener('click', finishQuiz);

  // Nav buttons ----------------------------------------------------------
  overlay.querySelectorAll('[data-next]').forEach((btn) => {
    btn.addEventListener('click', () => { step++; showStep(step); });
  });
  overlay.querySelectorAll('[data-back]').forEach((btn) => {
    btn.addEventListener('click', () => { step--; showStep(step); });
  });

  function renderResult() {
    const info = HD_SIZE_COPY[state.size] || HD_SIZE_COPY.Medium;
    const pronoun = state.gender === 'Female' ? 'her' : 'his';
    const name = state.name || 'Your dog';
    document.getElementById('result-name').textContent = name;
    document.getElementById('result-pronoun').textContent = pronoun;
    document.getElementById('result-size-label').textContent = `${info.label} · ${info.range}`;
    const img = document.getElementById('result-image');
    if (img) img.src = info.img;
    const cta = document.getElementById('result-cta');
    const baseProductUrl = (window.HD && window.HD.settings && window.HD.settings.productUrl) || '#';
    if (cta) cta.href = `${baseProductUrl}?size=${encodeURIComponent(info.label)}&name=${encodeURIComponent(name)}`;
  }
})();
